import { UNAUTHORIZED_USER } from "../types/authTypes";
import {
  TEMP_UPLOAD_ERROR,
  TEMP_UPLOAD_RESET,
  TEMP_UPLOAD_SUCCESS,
} from "../types/tempUploadTypes";

const initState = {
  tempUploadSuccess: false,
  tempUploadError: false,
  tempUploadMessage: null,
  tempUploadData: null,
};

const tempUploadReducer = (state = initState, action) => {
  switch (action.type) {
    case TEMP_UPLOAD_SUCCESS:
      return {
        ...state,
        tempUploadSuccess: true,
        tempUploadError: false,
        tempUploadMessage: action.message || "File uploaded successfully.",
        tempUploadData: action.payload,
      };
    case TEMP_UPLOAD_ERROR:
      return {
        ...state,
        tempUploadSuccess: false,
        tempUploadError: true,
        tempUploadMessage: action.message || "Failed to upload file.",
        tempUploadData: null,
      };
    case TEMP_UPLOAD_RESET:
      return {
        ...state,
        ...(action.payload || {}),
      };

    case UNAUTHORIZED_USER:
      return initState;
    default:
      return state;
  }
};

export default tempUploadReducer;
